document.addEventListener('DOMContentLoaded', function () {
  const quantitySelect = document.getElementById("product-quantity-select");
  const quantityInput = document.getElementById("product-quantity-input");
  const quantityInputWrapper = quantityInput?.closest('.form-field--qty-input');
  const quantitySelectWrapper = quantitySelect?.closest('.form-field--qty-select');
  const variantSelect = document.querySelector('select[data-variants]');
  const priceEl = document.querySelector('.product-pricing .money[data-price]');

  if (!variantSelect || (!quantitySelect && !quantityInput) || !priceEl) return;

  function updatePrice() {
    const selectedOption = variantSelect.options[variantSelect.selectedIndex];
    const unitPrice = parseFloat(selectedOption.dataset.price);

    const isInputVisible = quantityInputWrapper && !quantityInputWrapper.classList.contains('hidden');
    const customQuantity = isInputVisible ? parseInt(quantityInput.value, 10) : NaN;
    const selectQuantity = !isInputVisible ? parseInt(quantitySelect.value, 10) : NaN;

    const quantity = !isNaN(customQuantity) && customQuantity > 0
      ? customQuantity
      : (!isNaN(selectQuantity) && selectQuantity > 0 ? selectQuantity : 1);

    if (!isNaN(unitPrice)) {
      const totalPrice = unitPrice * quantity;
      priceEl.textContent = formatPrice(totalPrice);
    }
  }

  // Handle select change
  if (quantitySelect) {
    quantitySelect.addEventListener('change', function () {
      if (quantitySelect.value === '10+') {
        showInputField();
      }
      updatePrice();
    });
  }

  // Handle input change
  if (quantityInput) {
    quantityInput.addEventListener('input', updatePrice);

    // Optional: reset if input is cleared or less than 10
    quantityInput.addEventListener('blur', function () {
      const inputVal = parseInt(quantityInput.value, 10);
      if (isNaN(inputVal) || inputVal < 10) {
        hideInputField();
        updatePrice();
      }
    });
  }

  // Handle variant change
  variantSelect.addEventListener('change', updatePrice);

  // === FIX: If page loads with "10+" selected ===
  if (quantitySelect && quantitySelect.value === '10+') {
    showInputField();
  }

  updatePrice(); // Run once on page load

  // Helper to show input field
  function showInputField() {
    quantitySelectWrapper?.classList.add('hidden');
    quantityInputWrapper?.classList.remove('hidden');
    quantityInput.focus();

    // Optional: prefill input if empty or less than 10
    const inputVal = parseInt(quantityInput.value, 10);
    if (isNaN(inputVal) || inputVal < 10) {
      quantityInput.value = '10';
    }
  }

  // Helper to hide input field and go back to select
  function hideInputField() {
    quantityInputWrapper?.classList.add('hidden');
    quantitySelectWrapper?.classList.remove('hidden');
    quantitySelect.value = '1'; // reset to 1 or any default you want
  }
});

function formatPrice(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD'
  }).format(amount);
}